module.exports = __webpack_public_path__ + "media/images/career_camp/2023/user_1-97025d067ef2b51dfc4d973b89f2b6f4.png";